import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import { canAccess, getMenuItems } from './functions'
import messages from '../utils/messages'

Vue.use(Router)

var router = new Router({
    routes: routes,
    hashbang: false,
    mode: 'history'
});

// Authenticate routes here (RouteGuard)
router.beforeResolve(function(to, from, next){
    if (to.matched.some(record => record.meta.authEmployee)) {
        console.log("Requires Employee!");
        alert("Du har desværre ikke adgang til denne side. Det er kun for medarbejdere.");
    } else if (to.matched.some(record => record.meta.authAdmin)) {
        console.log("Requires admin!");
        alert("Du har desværre ikke adgang til denne side. Administrator rettigheder påkrævet.");
    } else {
        next() // make sure to always call next()!
    }
});

router.afterEach((to, from) => {
    messages.clear();
})

export { canAccess, getMenuItems }

export default router


// WEBPACK FOOTER //
// ./src/router/index.js